import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ArcTeamMembershipDto {
  @Field(t => Int)
  teamId?: number

  @Field(t => Int)
  memberUserId?: number

  @Field(t => Int, { nullable: true })
  status?: number

  @Field(t => Int, { nullable: true })
  reviewerStatus?: number

  @Field({ nullable: true })
  userRequested?: boolean

  @Field(t => Int, { nullable: true })
  userEmailId?: number
}
